const relatedProducts = [
  {
    id: 1,
    name: '삼성전자 990 PRO 1TB',
    price: 129000,
    originalPrice: 169000,
    image:
      'https://public.readdy.ai/ai/img_res/fe23d81cad4e8a681e58e50efd551c62.jpg',
    badge: '인기',
    rating: 4.8,
    reviews: 95,
  },
  {
    id: 2,
    name: '삼성전자 980 PRO 2TB',
    price: 179000,
    originalPrice: 239000,
    image:
      'https://readdy.ai/api/search-image?query=Samsung%20980%20PRO%202TB%20NVMe%20M.2%20SSD%20solid%20state%20drive%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20studio%20lighting&width=400&height=400&seq=related-980pro-2tb-002&orientation=squarish',
    badge: '할인',
    rating: 4.7,
    reviews: 210,
  },
  {
    id: 3,
    name: '삼성전자 870 EVO 2TB SATA',
    price: 159000,
    originalPrice: 199000,
    image:
      'https://readdy.ai/api/search-image?query=Samsung%20870%20EVO%202TB%20SATA%20SSD%20solid%20state%20drive%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20studio%20lighting&width=400&height=400&seq=related-870evo-2tb-003&orientation=squarish',
    badge: 'SATA',
    rating: 4.9,
    reviews: 340,
  },
  {
    id: 4,
    name: '삼성전자 990 EVO Plus 2TB',
    price: 189000,
    originalPrice: 249000,
    image:
      'https://readdy.ai/api/search-image?query=Samsung%20990%20EVO%20Plus%202TB%20NVMe%20M.2%20SSD%20solid%20state%20drive%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20studio%20lighting&width=400&height=400&seq=related-990evo-2tb-004&orientation=squarish',
    badge: '신제품',
    rating: 4.8,
    reviews: 42,
  },
];

export default relatedProducts;
